import { Badge, Flex, Spoiler, Text, Title } from '@mantine/core';

import classes from './candidate-pick-drawer.module.scss';

type MatchPalette = 'red' | 'yellow' | 'blue' | 'green';

const MATCH_REASON_COLLAPSED_HEIGHT = 72;

const MATCH_STATUS: Record<MatchPalette, string> = {
  green: 'Подходит',
  blue: 'Хороший потенциал',
  yellow: 'Слабый потенциал',
  red: 'Не подходит',
};

const getMatchPalette = (percent: number): MatchPalette => {
  const normalizedPercent = Math.min(
    100,
    Math.max(0, Number.isFinite(percent) ? percent : 0)
  );

  if (normalizedPercent <= 25) {
    return 'red';
  }
  if (normalizedPercent <= 50) {
    return 'yellow';
  }
  if (normalizedPercent <= 75) {
    return 'blue';
  }
  return 'green';
};

type CandidateMatchAssessmentProps = {
  matchPercent: number;
  analysis: string;
  resetKey: number;
};

export const CandidateMatchAssessment = ({
  matchPercent,
  analysis,
  resetKey,
}: CandidateMatchAssessmentProps) => {
  const matchPalette = getMatchPalette(matchPercent);

  return (
    <Flex
      className={classes.matchBlock}
      data-palette={matchPalette}
      direction='column'
    >
      <Flex justify='space-between' align='center' px={16} pt={16}>
        <Text size='sm' c='tertiary.7'>
          Оценка соответствия кандидата
        </Text>
        <Badge variant='filled' color={matchPalette} size='xs'>
          {MATCH_STATUS[matchPalette]}
        </Badge>
      </Flex>

      <Flex className={classes.matchContent}>
        <Title order={4} lh={1} c='primary.7'>
          {matchPercent} %
        </Title>
        {analysis === '—' ? (
          <Text size='md' c='primary.7' className={classes.matchReason}>
            {analysis}
          </Text>
        ) : (
          <Spoiler
            key={resetKey}
            className={classes.matchReason}
            maxHeight={MATCH_REASON_COLLAPSED_HEIGHT}
            showLabel='Показать'
            hideLabel='Скрыть'
            styles={{ control: { textDecoration: 'none' } }}
          >
            <Text size='md' c='primary.7'>
              {analysis}
            </Text>
          </Spoiler>
        )}
      </Flex>
    </Flex>
  );
};
